import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import { NoWorkflow } from "../../shared/Noworkflow";
import MainStore from "../home/store/mainStore";
import { MaterialUsageBaseView } from "./components/MaterialUsageBaseView";

const mainstore = createContext(MainStore);

export const MaterialBaseView = observer(() => {
  const mainStore = useContext(mainstore);

  switch (mainStore.assetContextId) {
    case 1:
      return <NoWorkflow />;
    case 2:
    case 3:
      return <MaterialUsageBaseView />;

    default:
      return <NoWorkflow />;
  }
});

